/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { ProjectTestPaginated } from '../model';
// @ts-ignore
import type { ProjectTestSorting } from '../model';
// @ts-ignore
import type { ProjectTestType } from '../model';
/**
 * ProjectTestsApi - axios parameter creator
 */
export const ProjectTestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List the project\'s tests, agent and metric, in one page.  Soft-deleted agent tests are excluded. Agent rows — and their share of the verdict counts in ``extra`` — are excluded when the organization\'s ``agent_test`` flag is off.
         * @summary Get Project Tests
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {ProjectTestSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {boolean} [exactMatch] 
         * @param {ProjectTestType | null} [testType] 
         * @param {string | null} [notMappedToControlId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectTests: async (projectId: string, page?: number, size?: number, sortBy?: ProjectTestSorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, exactMatch?: boolean, testType?: ProjectTestType | null, notMappedToControlId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectTests', 'projectId', projectId)
            const localVarPath = `/project-tests/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (nameOrUniqueCode !== undefined) {
                localVarQueryParameter['name_or_unique_code'] = nameOrUniqueCode;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            if (testType !== undefined) {
                localVarQueryParameter['test_type'] = testType;
            }

            if (notMappedToControlId !== undefined) {
                localVarQueryParameter['not_mapped_to_control_id'] = notMappedToControlId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectTestsApi - functional programming interface
 */
export const ProjectTestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectTestsApiAxiosParamCreator(configuration)
    return {
        /**
         * List the project\'s tests, agent and metric, in one page.  Soft-deleted agent tests are excluded. Agent rows — and their share of the verdict counts in ``extra`` — are excluded when the organization\'s ``agent_test`` flag is off.
         * @summary Get Project Tests
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {ProjectTestSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {boolean} [exactMatch] 
         * @param {ProjectTestType | null} [testType] 
         * @param {string | null} [notMappedToControlId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectTests(projectId: string, page?: number, size?: number, sortBy?: ProjectTestSorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, exactMatch?: boolean, testType?: ProjectTestType | null, notMappedToControlId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectTestPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectTests(projectId, page, size, sortBy, descending, nameOrUniqueCode, exactMatch, testType, notMappedToControlId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectTestsApi.getProjectTests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectTestsApi - factory interface
 */
export const ProjectTestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectTestsApiFp(configuration)
    return {
        /**
         * List the project\'s tests, agent and metric, in one page.  Soft-deleted agent tests are excluded. Agent rows — and their share of the verdict counts in ``extra`` — are excluded when the organization\'s ``agent_test`` flag is off.
         * @summary Get Project Tests
         * @param {ProjectTestsApiGetProjectTestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectTests(requestParameters: ProjectTestsApiGetProjectTestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectTestPaginated> {
            return localVarFp.getProjectTests(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, requestParameters.exactMatch, requestParameters.testType, requestParameters.notMappedToControlId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getProjectTests operation in ProjectTestsApi.
 */
export interface ProjectTestsApiGetProjectTestsRequest {
    readonly projectId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: ProjectTestSorting | null

    readonly descending?: boolean | null

    readonly nameOrUniqueCode?: string | null

    readonly exactMatch?: boolean

    readonly testType?: ProjectTestType | null

    readonly notMappedToControlId?: string | null
}

/**
 * ProjectTestsApi - object-oriented interface
 */
export class ProjectTestsApi extends BaseAPI {
    /**
     * List the project\'s tests, agent and metric, in one page.  Soft-deleted agent tests are excluded. Agent rows — and their share of the verdict counts in ``extra`` — are excluded when the organization\'s ``agent_test`` flag is off.
     * @summary Get Project Tests
     * @param {ProjectTestsApiGetProjectTestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectTests(requestParameters: ProjectTestsApiGetProjectTestsRequest, options?: RawAxiosRequestConfig) {
        return ProjectTestsApiFp(this.configuration).getProjectTests(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, requestParameters.exactMatch, requestParameters.testType, requestParameters.notMappedToControlId, options).then((request) => request(this.axios, this.basePath));
    }
}

